import { GroupsEnum } from "@/enum/groups";

export const PATH_IDS = {
  CONCILIACAO: "/conciliacao",
  TI: "/ti",
  FINANCEIRO: "/financeiro",
  RETAGUARDA_DE_LOJA: "/retaguarda-de-loja",
  FISCAL: "/fiscal",
  CRM: "/crm",
  RECURSOS_HUMANOS: "/rh",
  ETIQUETA_REMARCADOS: "/etiqueta-remarcados",
  REMARCACAO_DE_PRECO: "/remarcacao-de-preco",
  PLANEJAMENTO_COMERCIAL: "/planejamento-comercial",
} as const satisfies Partial<Record<GroupsEnum, string>>;
